module.exports = __webpack_public_path__ + "img/search-index.3d62bca0.png";